import { render } from "./PlanTransportGroupResultDetail3DJournal.vue?vue&type=template&id=33ef1c61&scoped=true&ts=true"
import script from "./PlanTransportGroupResultDetail3DJournal.vue?vue&type=script&lang=ts"
export * from "./PlanTransportGroupResultDetail3DJournal.vue?vue&type=script&lang=ts"

import "./PlanTransportGroupResultDetail3DJournal.vue?vue&type=style&index=0&id=33ef1c61&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ef1c61"]])

export default __exports__